"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _constant = require("../../constant");
var _default = {
  PropTypes: {
    disableScroll: _propTypes.default.bool,
    items: _propTypes.default.arrayOf(_propTypes.default.shape({
      label: _propTypes.default.string,
      value: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number])
    })).isRequired,
    value: _propTypes.default.string,
    showPicker: _propTypes.default.bool,
    onValueChange: _propTypes.default.func,
    renderOptionLabel: _propTypes.default.func,
    maxHeight: _propTypes.default.number,
    enablePaxAgeUpdate: _propTypes.default.bool
  },
  DefaultProps: {
    disableScroll: false,
    value: '',
    showPicker: false,
    onValueChange: function onValueChange() {},
    maxHeight: _constant.MAX_HEIGHT,
    enablePaxAgeUpdate: false
  }
};
exports.default = _default;